import { Link } from 'react-router-dom';
import type { OrderHistoryEntry } from '../../types';
import { getStatusBadgeClass, getStatusLabel } from '../../utils/orderStatus';
import { getEffectiveRefundStatus } from '../../utils/recentOrders';
import { formatDateTime } from '../../utils/dateFormat';
import { buildPrintPath } from '../../utils/labels';

interface OrdersTableProps {
  orders: OrderHistoryEntry[];
  onViewTracking: (order: OrderHistoryEntry) => void;
  onCancel: (order: OrderHistoryEntry) => void;
}

function OrdersTable({ orders, onViewTracking, onCancel }: OrdersTableProps) {
  return (
    <div className="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Date</th>
            <th>Recipient</th>
            <th>Destination</th>
            <th>Tracking</th>
            <th>Label</th>
            <th>Status</th>
            <th style={{ textAlign: 'right' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.record_key || order.shipment_id}>
              <td data-label="Date" className="td-mono td-muted" style={{ fontSize: '0.72rem', whiteSpace: 'nowrap' }}>
                {formatDateTime(order.created_at)}
              </td>
              <td data-label="Recipient"><strong>{order.recipient || '-'}</strong></td>
              <td data-label="Destination">{order.destination || '-'}</td>
              <td data-label="Tracking" className="td-mono" style={{ fontSize: '0.72rem' }}>
                {order.tracking_code || '-'}
              </td>
              <td data-label="Label">
                {order.label_url ? (
                  <Link to={buildPrintPath(order.label_url, order.label_file_type)}>View label</Link>
                ) : (
                  '-'
                )}
              </td>
              <td data-label="Status">
                <span className={`status-badge ${getStatusBadgeClass(order)}`}>
                  <span className="dot" />
                  {getStatusLabel(order)}
                </span>
                {order.est_delivery_date && (
                  <div style={{ fontSize: '0.68rem', color: 'var(--muted)', marginTop: '4px' }}>
                    Est: {new Date(order.est_delivery_date).toLocaleDateString()}
                  </div>
                )}
              </td>
              <td data-label="Actions" style={{ textAlign: 'right' }}>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                  {order.tracking_code && (
                    <button
                      className="btn btn-secondary btn-small"
                      onClick={() => onViewTracking(order)}
                    >
                      Track
                    </button>
                  )}
                  {order.status === 'purchased' && !getEffectiveRefundStatus(order) && (
                    <button
                      className="btn btn-danger btn-small"
                      onClick={() => onCancel(order)}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default OrdersTable;
